import React, { useContext, useEffect, useState } from "react";
import { graphql, Link, useStaticQuery } from "gatsby";
import { DocumentContext } from "~context/DocumentContext";

const Footer = () => {
  const { device } = useContext(DocumentContext);

  const [expanded, setExpanded] = useState(false);

  //

  const { allDataYaml } = useStaticQuery(graphql`
    query Footer {
      allDataYaml {
        edges {
          node {
            footer {
              credits {
                name
                role
                url
              }
            }
          }
        }
      }
    }
  `);

  let credits;

  if (allDataYaml?.edges?.[0]?.node?.footer) {
    ({ credits } = allDataYaml.edges[0].node.footer);
  }

  //

  useEffect(() => {
    if (!expanded) {
      return;
    }

    if (window && typeof window !== `undefined`) {
      window.scrollTo({
        top: document.documentElement.offsetHeight,
        behavior: `smooth`
      });
    }
  }, [expanded]);

  //

  return (
    <footer className="footer w-full relative pt-16 md:pt-20 bg-light-green text-bone">
      <div className="grid">
        <div className="md:grid-end-6 relative px-6 text-center">
          <h3 className="f5">Resources</h3>

          <ul className="w-full relative">
            <li className={`${device && device !== `mobile` ? `f2` : `f3`}`}>
              <Link to="/faqs" className="footer__link block md:pt-2 md:pb-2">
                FAQs
              </Link>
            </li>

            <li className={`${device && device !== `mobile` ? `f2` : `f3`}`}>
              <Link
                to="/faqs#faq-deliveries"
                className="footer__link block md:pt-2 md:pb-2"
              >
                Deliveries
              </Link>
            </li>

            <li className={`${device && device !== `mobile` ? `f2` : `f3`}`}>
              <Link
                to="/faqs#faq-wholesale"
                className="footer__link block md:pt-2 md:pb-2"
              >
                Wholesale
              </Link>
            </li>

            <li className={`${device && device !== `mobile` ? `f2` : `f3`}`}>
              <Link
                to="/faqs#faq-sustainability"
                className="footer__link block md:pt-2 md:pb-2"
              >
                Sustainability
              </Link>
            </li>

            <li className={`${device && device !== `mobile` ? `f2` : `f3`}`}>
              <Link
                to="/faqs#faq-privacy"
                className="footer__link block md:pt-2 md:pb-2"
              >
                Privacy
              </Link>
            </li>

            <li className={`${device && device !== `mobile` ? `f2` : `f3`}`}>
              <Link
                to="/faqs#faq-terms"
                className="footer__link block md:pt-2 md:pb-2"
              >
                Terms
              </Link>
            </li>
          </ul>
        </div>

        <div className="md:grid-end-6 relative mt-8 md:mt-0 px-6 text-center">
          <h3 className="f5">Connect</h3>

          <ul className="w-full relative">
            <li className={`${device && device !== `mobile` ? `f2` : `f3`}`}>
              <a
                href="https://www.instagram.com/wildwoodbakerypreston/"
                rel="noopener noreferrer"
                target="_blank"
                className="footer__link block md:pt-2 md:pb-2"
              >
                Instagram
              </a>
            </li>

            <li className={`${device && device !== `mobile` ? `f2` : `f3`}`}>
              <a
                href="https://www.facebook.com/wildwoodbakerypreston/"
                rel="noopener noreferrer"
                target="_blank"
                className="footer__link block md:pt-2 md:pb-2"
              >
                Facebook
              </a>
            </li>
          </ul>

          <h3 className="mt-8 md:mt-8 f5">Contact</h3>

          <a
            href="mailto:info@wildwoodbakery.com.au"
            className="footer__link block md:pt-2 md:pb-2 break-all f2"
          >
            info@wildwoodbakery.com.au
          </a>
        </div>
      </div>

      <div className="w-full relative block mt-16 md:mt-24">
        <img
          className="w-full relative block"
          src="/uploads/footer-wave.png"
          alt="Grassland"
        />

        <div className="w-full absolute bottom-0 right-0 left-0 z-10 flex items-center justify-center">
          <button
            type="button"
            className="hover-underline relative block pt-4 pb-6"
            onClick={() => setExpanded(!expanded)}
          >
            <span
              className={`${
                device && device !== `mobile` ? `b1` : `f5`
              } text-cream`}
            >
              Site credit
            </span>
            <span
              className={`ml-2 ${
                device && device !== `mobile` ? `b1` : `f5`
              } text-cream`}
            >
              {expanded ? `-` : `+`}
            </span>
          </button>
        </div>
      </div>

      {expanded && (
        <div className="w-full relative flex items-center justify-center pt-5 px-6 pb-5 bg-dark-green">
          <h4 className="w-full relative block break-words f5 text-center">
            {credits.map(credit => {
              return (
                <>
                  <span className="text-light-green">{credit.role}:</span>

                  {(credit?.url && (
                    <a
                      href={credit.url}
                      rel="noopener noreferrer"
                      target="_blank"
                      className="hover-underline ml-2 text-orange"
                    >
                      {credit.name}
                      {` `}
                    </a>
                  )) || (
                    <span className="ml-2 text-orange">
                      {credit.name}
                      {` `}
                    </span>
                  )}
                </>
              );
            })}
          </h4>
        </div>
      )}
    </footer>
  );
};

export default Footer;
